import { render, staticRenderFns } from "./AdminMessageEmailSection.vue?vue&type=template&id=348e4a92"
import script from "./AdminMessageEmailSection.vue?vue&type=script&lang=js"
export * from "./AdminMessageEmailSection.vue?vue&type=script&lang=js"
import style0 from "./AdminMessageEmailSection.vue?vue&type=style&index=0&id=348e4a92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports